import { render, staticRenderFns } from "./Fav.vue?vue&type=template&id=b9982e3a&scoped=true"
import script from "./Fav.vue?vue&type=script&lang=js"
export * from "./Fav.vue?vue&type=script&lang=js"
import style0 from "./Fav.vue?vue&type=style&index=0&id=b9982e3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9982e3a",
  null
  
)

export default component.exports